import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { api } from '../../../core/network/api';
import { transferKeys } from '../queries/keys';
import { transferPaths } from '../queries/paths';

// Mutations / reads de sesiones TE (api-reference/admin-transfer-sessions.md).
// El create es COMPUESTO: sesión + staff + transfers en una transacción; abre las
// preñeces y agenda la dx1 en el backend (el form no envía esas fechas).

export function useCreateTransferSession() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (payload) => api.post(transferPaths.sessions(), payload).then(r => r.data),
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: transferKeys.all });
            qc.invalidateQueries({ queryKey: ['opu'] }); // refresca counts/timeline de la OPU
        },
    });
}

export function useTransferSession(id) {
    return useQuery({
        queryKey: transferKeys.detail(id),
        queryFn:  ({ signal }) => api.get(transferPaths.session(id), { signal }).then(r => r.data),
        enabled:  !!id && id !== 'new',
    });
}

// Edita el encabezado de la sesión TE (date/farm_id/status/remarks).
export function useUpdateTransferSession(id) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (body) => api.patch(transferPaths.session(id), body).then(r => r.data),
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: transferKeys.all });
            qc.invalidateQueries({ queryKey: ['opu'] });
        },
    });
}

// Las ediciones/deshacer de transferencias anidadas (recipient/remarks/delete) se
// hacen con api.patch/api.delete directos en el tablero (transfer-rows): una fila
// puede pertenecer a CUALQUIER sesión de la OPU (row.sessionId varía), por lo que
// no encajan en un hook atado a un único sessionId. Restricciones del backend:
// 422 si el linaje quedó congelado, 409 al borrar con preñez progresada.

// Sesiones TE asociadas a una OPU (para reanudar) + pool de embriones disponibles.
// Read derivado de la OPU (decisión 0019).
export function useOpuTransferSessions(opuId, opts = {}) {
    return useQuery({
        queryKey: ['transfer-sessions', 'opu', opuId],
        queryFn:  ({ signal }) => api.get(transferPaths.opuSessions(opuId), { signal }).then(r => r.data),
        ...opts,
        enabled:  !!opuId, // guard después del spread: no se puede clobberear
    });
}
